import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import EventIcon from '@material-ui/icons/Event';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import Button from 'Components/UI/Button';
import Typography from 'Components/UI/Typography';

const abbrs = {
  EST: 'Eastern Standard Time',
  EDT: 'Eastern Daylight Time',
  CST: 'Central Standard Time',
  CDT: 'Central Daylight Time',
  MST: 'Mountain Standard Time',
  MDT: 'Mountain Daylight Time',
  PST: 'Pacific Standard Time',
  PDT: 'Pacific Daylight Time',
};

// eslint-disable-next-line func-names
moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr();
  return abbrs[abbr] || abbr;
};

const styles = (theme) => ({
  paper: {
    width: '100%',
  },
  root: {},
  dialogContainer: {
    color: theme.palette.facet.primaryBlue,
  },
  header: {
    margin: theme.spacing(3),
  },
  title: {
    fontWeight: 'bold',
  },
  optionList: {},
  option: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1, 3),
    '&:hover': {
      backgroundColor: theme.palette.facet.lightGray3,
      cursor: 'pointer',
    },
  },
  optionPrompt: {
    display: 'flex',
    flex: 1,
  },
  optionDate: {
    display: 'flex',
    flex: 1,
  },
  selected: {
    backgroundColor: theme.palette.facet.lightGray3,
  },
  buttonBarContainer: {
    padding: theme.spacing(0, 2),
  },
  buttonBar: {
    display: 'flex',
    flexDirection: 'row',
    borderTop: '1px solid',
    borderTopColor: theme.palette.facet.accentGray,
    padding: theme.spacing(1, 0, 2, 0),
  },
  datePicker: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: theme.palette.facet.lightGray3,
      cursor: 'pointer',
    },
    border: '0px solid',
    borderRadius: '10px',
    padding: theme.spacing(1),
  },
  datePickerIcon: {
    paddingRight: theme.spacing(0.25),
  },
  confirmationButton: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
  },
});

const ScheduleSendSelector = ({
  classes,
  meetingAgenda,
  setSelectedOption,
  selectedOption,
  setDatePickerIsOpen,
  handlePickDateTime,
}) => {
  const dateOptions = meetingAgenda.meta().field('scheduledSendType').options().itemList.filter(option => option.attr('group') !== undefined).map(option => {
    return (
      <div
        className={classNames(classes.option, selectedOption?.id() === option.id() ? classes.selected : {})}
        onClick={() => setSelectedOption(option)}
        onKeyPress={() => setSelectedOption(option)}
        role="button"
        tabIndex={0}
        key={`schedule-send-option-${option.id()}`}
      >
        <div className={classes.optionPrompt}>
          {option.attr('prompt')}
        </div>
        <div className={classes.optionDate}>
          {moment(option.attr('group')).set({ hour: 9, minute: 0, second: 0 }).format('lll')}
        </div>
      </div>
    );
  });

  return (
    <div className={classes.dialogContainer}>
      <div className={classes.header}>
        <Typography variant="h3" className={classes.title}>Schedule Send</Typography>
        <Typography variant="h6">{moment.tz(moment.tz.guess()).format('zz')}</Typography>
      </div>
      <div className={classes.optionList}>
        {dateOptions}
      </div>
      <div className={classes.buttonBarContainer}>
        <div className={classes.buttonBar}>
          <div
            className={classes.datePicker}
            onClick={() => setDatePickerIsOpen(true)}
            onKeyPress={() => setDatePickerIsOpen(true)}
            role="button"
            tabIndex={0}
            test={'scheduled-send-pick-date-time-button'}
          >
            <EventIcon className={classes.datePickerIcon} />
            <div>Pick date and time</div>
          </div>
          <div className={classes.confirmationButton}>
            <Button
              color="primary"
              disableElevation
              variant="contained"
              onClick={() => handlePickDateTime(moment(selectedOption.attr('group')).set({ hour: 9, minute: 0, second: 0 }), selectedOption.id())}
              disabled={!selectedOption}
            >
              {'Confirm'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

ScheduleSendSelector.defaultProps = {
  selectedOption: null,
};

ScheduleSendSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  handlePickDateTime: PropTypes.func.isRequired,
  setSelectedOption: PropTypes.func.isRequired,
  selectedOption: PropTypes.object,
  setDatePickerIsOpen: PropTypes.func.isRequired,
  meetingAgenda: PropTypes.object.isRequired,
};

export default withStyles(styles)(ScheduleSendSelector);
